const attachShadow = Element.prototype.attachShadow;

Element.prototype.attachShadow = function (init: ShadowRootInit) {
    if (this.localName === 'gmp-place-autocomplete') {
        const shadow = attachShadow.call(this, {
            ...init,
            mode: 'open', // Override to open
        });

        const style = document.createElement('style');
        style.textContent = `
      .full-window-autocomplete-dialog {
        background-color: white !important;
        color: rgb(var(--color-text-primary)) !important;
      }
      .full-window-autocomplete-dialog[open] .input-container button.clear-button {
        padding: 12px;
        width: 48px !important;
        height: 48px !important;
      }
      .full-window-autocomplete-dialog[open] .input-container button.back-button:hover {
        background-color: transparent !important;
      }
      .full-window-autocomplete-dialog .place-autocomplete-element-text-div,
      .full-window-autocomplete-dialog .place-autocomplete-element-place-name,
      .full-window-autocomplete-dialog .place-autocomplete-element-place-details,
      .full-window-autocomplete-dialog .place-autocomplete-element-place-result--matched {
        color: #1a1a1a !important;
      }
      .full-window-autocomplete-dialog input {
        color: #1a1a1a !important;
      }
      .input-container {
        padding: 0px !important;
      }
      .input-container div.autocomplete-icon {
        width: 24px !important;
        height: 24px !important;
      }
      .input-container button.clear-button {
        width: 24px !important;
        height: 24px !important;
        padding: 0 !important;
      }
      .input-container button.clear-button:hover, .input-container button.clear-button:focus {
        background-color: transparent !important;
      }
      .focus-ring {
        display: none !important;
      }
      .dropdown {
        background-color: white !important;
        border-radius: 8px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
      }
      .dropdown > ul > li[aria-selected="true"] {
        background-color: rgba(0,0,0,0.08) !important;
      }
      .place-autocomplete-element-row {
        gap: 0px !important;
      }
      .place-autocomplete-element-row .place-autocomplete-element-prediction-item-icon path {
        fill: var(--color-text-primary) !important;
      }
      .place-autocomplete-element-text-div,
      .place-autocomplete-element-place-name,
      .place-autocomplete-element-place-details,
      .place-autocomplete-element-place-result--matched {
        color: var(--color-text-primary) !important;
      }
      ul {
        border: none !important;
      }
      li {
        padding: 0px !important;
        margin: 5px !important;
        border: none !important;
        border-radius: 5px !important;
        min-height: 50px !important;
      }
      li:hover {
        cursor: pointer !important;
        padding: 0px !important;
        margin: 5px !important;
        background-color: rgba(0,0,0,0.1) !important;
      }
      input {
        color: var(--color-text-primary) !important;
        font-size: 14px !important;
      }
      .attributions {
        display: none !important;
      }
    `;

        shadow.appendChild(style);

        const observer = new MutationObserver(() => {
            const input = shadow.querySelector(
                'input[aria-label="Search For a Place"]',
            ) as HTMLInputElement;

            if (input) {
                input.placeholder = 'Search location';
                observer.disconnect(); // stop once we set it
            }

            const clearButton = shadow.querySelector('.clear-button');
            if (clearButton) {
                if (
                    !clearButton.querySelector('svg') ||
                    clearButton.querySelector('svg')?.getAttribute('data-custom') !== 'true'
                ) {
                    clearButton.textContent = '';

                    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                    svg.setAttribute('width', '18');
                    svg.setAttribute('height', '18');
                    svg.setAttribute('viewBox', '0 0 24 24');
                    svg.setAttribute('fill', 'none');
                    svg.setAttribute('stroke', 'currentColor');
                    svg.setAttribute('stroke-width', '2');
                    svg.setAttribute('stroke-linecap', 'round');
                    svg.setAttribute('stroke-linejoin', 'round');
                    svg.setAttribute('data-custom', 'true');
                    svg.innerHTML = `
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    `;

                    clearButton.appendChild(svg);
                }

                observer.disconnect();
            }
        });

        observer.observe(shadow, {
            childList: true,
            subtree: true,
        });

        return shadow;
    }

    return attachShadow.call(this, init);
};
